import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialog, MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Store } from '@ngxs/store';
import { DirectivesModule } from '@shared/directives/directives.module';
import { LinkTasksComponent } from '@shared/modules/legacy-tasks/link-tasks/link-tasks.component';
import { TaskState } from '@tasks/state/state';
import { Task, TaskList } from '@tasks/tasks.types';
@Component({
  selector: 'app-task-details-linked-task',
  standalone: true,
  imports: [
    CommonModule,
    MatLegacyButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatLegacyDialogModule,
    DirectivesModule,
  ],
  template: `
    <div class="flex flex-row">
      <div class="row">
        <button
          class="xs:hidden add-task"
          mat-flat-button
          (click)="openLinkTasksModal()"
          [appAuthorize]="canEditTask"
          denyAction="disable"
          *ngIf="task.linked_to?.length <= 0"
        >
          <mat-icon class="icon-size-20 mr-2" [svgIcon]="'link'"></mat-icon>
          Link Task
        </button>
        <ng-container *ngIf="task.linked_to?.length > 0">
          <ng-container *ngFor="let linkedTo of task.linked_to">
            <button
              class="xs:hidden add-task"
              mat-flat-button
              (click)="onUnlinkTask(linkedTo)"
              [appAuthorize]="canEditTask"
              denyAction="disable"
              [matTooltip]="linkedTo.linked_to_type + '::' + linkedTo.linked_to_reference_id"
            >
              <mat-icon class="icon-size-20 mr-2" [svgIcon]="'link_off'"></mat-icon>
              Unlink Task
            </button>
          </ng-container>
        </ng-container>
      </div>
    </div>
  `,
  styleUrl: './task-details-linked-task.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskDetailsLinkedTaskComponent implements OnInit {
  private store = inject(Store);
  private matDialog = inject(MatLegacyDialog);
  private destroyRef = inject(DestroyRef);

  @Input() canEditTask: boolean;
  @Input() task: Task;
  @Input() tasks: Task[];
  @Output() saveTask = new EventEmitter<Task>();
  @Output() unlinkTask = new EventEmitter<Task>();

  taskLists: TaskList[] = [];

  ngOnInit(): void {
    this.taskLists = this.store.selectSnapshot(TaskState.getSidebarItems);
  }

  openLinkTasksModal(): void {
    const taskLists = this.taskLists.map((taskList) => {
      return { name: taskList.name, id: taskList.id };
    });

    const dialogRef = this.matDialog.open(LinkTasksComponent, {
      data: { task: this.task, onlyTasks: this.tasks, taskLists: taskLists },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        if (result && result.linked_from_task_id) {
          this.task.linked_from_task_id = result.linked_from_task_id;
          this.saveTask.emit(this.task);
        }
      });
  }

  onUnlinkTask(linkedTo: Task): void {
    this.task.linked_to = this.task.linked_to.filter((task) => task.id !== linkedTo.id);
    this.unlinkTask.emit(linkedTo);
  }
}
